export default [
	// {
	// 	path: '/overseasJoinAssistant',
	// 	name: 'overseasJoinAssistant',
	// 	component: () => import(/* overseasJoinAssistant */ './index.vue'),
	// 	meta: {
	// 		title: '乐橙文化',
	// 		// keepAlive: true  //是否设置为缓存数据页面
	// 	},
	// 	children: [
	// 		{
	// 			path: 'index',
	// 			name: 'overseasJoinAssistant_index',
	// 			component: () => import(/* overseasJoinAssistant_index */ './pages/pay/web/index.vue'),
	// 			meta: {
	// 				title: '乐橙文化',
	// 				// keepAlive: true  //是否设置为缓存数据页面
	// 			},
	// 		},
	// 		{
	// 			path: 'indexTest',
	// 			name: 'overseasJoinAssistant_index_test',
	// 			component: () => import(/* overseasJoinAssistant_index_test */ './pages/pay/webTest/index.vue'),
	// 			meta: {
	// 				title: '乐橙文化',
	// 				// keepAlive: true  //是否设置为缓存数据页面
	// 			},
	// 		}
	// 	]
	// },
	// {
	// 	path: '/LCWXJoinAssistant',
	// 	name: 'LCWXJoinAssistant',
	// 	component: () => import(/* LCWXJoinAssistant */ './index.vue'),
	// 	meta: {
	// 		title: '乐橙文化',
	// 		// keepAlive: true  //是否设置为缓存数据页面
	// 	},
	// 	children: [
	// 		{
	// 			path: 'index',
	// 			name: 'LCWXJoinAssistant_index',
	// 			component: () => import(/* LCWXJoinAssistant_index */ './pages/pay/wx/index.vue'),
	// 			meta: {
	// 				title: '乐橙文化',
	// 				auth: true, // 如果此路由需要微信授权请设置为true,默认为false
	// 				// keepAlive: true  //是否设置为缓存数据页面
	// 			}
	// 		},
	// 		{
	// 			path: 'success',
	// 			name: 'LCWXJoinAssistant_success',
	// 			component: () => import(/* LCWXJoinAssistant_success */ './pages/pay/wx/success.vue'),
	// 			meta: {
	// 				title: '乐橙文化',
	// 				auth: false, // 如果此路由需要微信授权请设置为true,默认为false
	// 				// keepAlive: true  //是否设置为缓存数据页面
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '/LCBlankJoinAssistant',
	// 	name: 'LCBlankJoinAssistant',
	// 	component: () => import(/* LCBlankJoinAssistant */ './index.vue'),
	// 	meta: {
	// 		title: '乐橙文化',
	// 		// keepAlive: true  //是否设置为缓存数据页面
	// 	},
	// 	children: [
	// 		{
	// 			path: 'index',
	// 			name: 'LCBlankJoinAssistant_index',
	// 			component: () => import(/* LCBlankJoinAssistant_index */ './pages/pay/blank/index.vue'),
	// 			meta: {
	// 				title: '乐橙文化',
	// 				// keepAlive: true  //是否设置为缓存数据页面
	// 			},
	// 		}
	// 	]
	// },
	// {
	// 	path: '/overseasFreeJoinAssistant',
	// 	name: 'overseasFreeJoinAssistant',
	// 	component: () => import(/* overseasFreeJoinAssistant */ './index.vue'),
	// 	meta: {
	// 		title: '乐橙文化',
	// 		// keepAlive: true  //是否设置为缓存数据页面
	// 	},
	// 	// children: [
	// 	// 	{
	// 	// 		path: 'index',
	// 	// 		name: 'overseasFreeJoinAssistant_index',
	// 	// 		component: () => import(/* overseasFreeJoinAssistant_index */ './pages/free/web/index.vue'),
	// 	// 		meta: {
	// 	// 			title: '乐橙文化',
	// 	// 			// keepAlive: true  //是否设置为缓存数据页面
	// 	// 		},
	// 	// 	},
	// 	// 	{
	// 	// 		path: 'indexQuestion',
	// 	// 		name: 'overseasFreeJoinAssistant_indexQuestion',
	// 	// 		component: () => import(/* overseasFreeJoinAssistant_indexQuestion */ './pages/free/web/indexQuestion.vue'),
	// 	// 		meta: {
	// 	// 			title: '乐橙文化',
	// 	// 			// keepAlive: true  //是否设置为缓存数据页面
	// 	// 		},
	// 	// 	},
	// 	// 	{
	// 	// 		path: 'phoneLanding',
	// 	// 		name: 'overseasFreeJoinAssistant_phoneLanding',
	// 	// 		component: () => import(/* overseasFreeJoinAssistant_phoneLanding */ './pages/free/web/phoneLanding.vue'),
	// 	// 		meta: {
	// 	// 			title: '乐橙文化',
	// 	// 			// keepAlive: true  //是否设置为缓存数据页面
	// 	// 		},
	// 	// 	},
	// 	// 	{
	// 	// 		path: 'answerQuestion',
	// 	// 		name: 'overseasFreeJoinAssistant_answerQuestion',
	// 	// 		component: () => import(/* overseasFreeJoinAssistant_answerQuestion */ './pages/free/web/answerQuestion.vue'),
	// 	// 		meta: {
	// 	// 			title: '乐橙文化',
	// 	// 			// keepAlive: true  //是否设置为缓存数据页面
	// 	// 		},
	// 	// 	},
	// 	// 	{
	// 	// 		path: 'qrCode',
	// 	// 		name: 'overseasFreeJoinAssistant_qrcode',
	// 	// 		component: () => import(/* overseasFreeJoinAssistant_qrCode */ './pages/free/web/qrCode.vue'),
	// 	// 		meta: {
	// 	// 			title: '乐橙文化',
	// 	// 			// keepAlive: true  //是否设置为缓存数据页面
	// 	// 		},
	// 	// 	},
	// 	// 	{
	// 	// 		path: 'gameOver',
	// 	// 		name: 'overseasFreeJoinAssistant_gameOver',
	// 	// 		component: () => import(/* overseasFreeJoinAssistant_gameOver */ './pages/free/web/gameOver.vue'),
	// 	// 		meta: {
	// 	// 			title: '乐橙文化',
	// 	// 			// keepAlive: true  //是否设置为缓存数据页面
	// 	// 		},
	// 	// 	}
	// 	// ]
	// },
	{
		path: '/overseasFreeJoinAssistant/indexQuestion',
		name: 'overseasFreeJoinAssistant_indexQuestion',
		component: () => import(/* overseasFreeJoinAssistant_indexQuestion */ './pages/free/web/indexQuestion.vue'),
		meta: {
			title: '乐橙文化',
			// keepAlive: true  //是否设置为缓存数据页面
		},
	},
	{
		path: '/overseasFreeJoinAssistant/phoneLanding/:id',
		name: 'overseasFreeJoinAssistant_phoneLanding',
		component: () => import(/* overseasFreeJoinAssistant_phoneLanding */ './pages/free/web/phoneLanding.vue'),
		meta: {
			title: '乐橙文化',
			// keepAlive: true  //是否设置为缓存数据页面
		},
	},
	{
		path: '/overseasFreeJoinAssistant/phoneLandingNew/:id',
		name: 'overseasFreeJoinAssistant_phoneLandingNew',
		component: () => import(/* overseasFreeJoinAssistant_phoneLanding */ './pages/free/web/phoneLandingNew.vue'),
		meta: {
			title: '乐橙文化',
			// keepAlive: true  //是否设置为缓存数据页面
		},
	},
	{
		path: '/overseasFreeJoinAssistant/answerQuestion',
		name: 'overseasFreeJoinAssistant_answerQuestion',
		component: () => import(/* overseasFreeJoinAssistant_answerQuestion */ './pages/free/web/answerQuestion.vue'),
		meta: {
			title: '乐橙文化',
			// keepAlive: true  //是否设置为缓存数据页面
		},
	},
	{
		path: '/overseasFreeJoinAssistant/qrCode',
		name: 'overseasFreeJoinAssistant_qrcode',
		component: () => import(/* overseasFreeJoinAssistant_qrCode */ './pages/free/web/qrCode.vue'),
		meta: {
			title: '乐橙文化',
			// keepAlive: true  //是否设置为缓存数据页面
		},
	},
	{
		path: '/overseasFreeJoinAssistant/activityOver',
		name: 'overseasFreeJoinAssistant_activityOver',
		component: () => import(/* overseasFreeJoinAssistant_gameOver */ './pages/free/web/activityOver.vue'),
		meta: {
			title: '乐橙文化',
			// keepAlive: true  //是否设置为缓存数据页面
		},
	}
]
